var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-upload--cloud-server-internet-upload-up-arrow-network"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32.5 38.871c.389-.013.765-.026 1.13-.04C40.232 38.568 45 34.106 45 27.5c0-5.437-3.228-9.42-8.05-10.807-.527-6.778-5.164-11.64-12.173-11.69a109.576 109.576 0 0 0-1.554 0c-7.009.05-11.646 4.912-12.173 11.69C6.228 18.08 3 22.063 3 27.5c0 6.607 4.768 11.069 11.37 11.33.365.015.741.028 1.13.041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    stroke: "#000000",
    strokeLinejoin: "round",
    d: "M15.145 26.428c-1.189 1.49-.376 3.29 1.527 3.4a97.85 97.85 0 0 0 3.345.129l.392 10.177c.056 1.46.947 2.718 2.402 2.824.352.026.747.042 1.189.042.442 0 .837-.016 1.189-.042 1.456-.106 2.346-1.365 2.402-2.823l.392-10.178a97.82 97.82 0 0 0 3.344-.13c1.903-.11 2.716-1.91 1.527-3.4A75.229 75.229 0 0 0 30 23.083c-1.913-2.127-3.369-3.382-4.367-4.113-1-.732-2.265-.732-3.266 0-.998.731-2.454 1.986-4.367 4.113a75.087 75.087 0 0 0-2.855 3.346Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.dedd641c6b1e9f14dc0396fb40126bed.svg";
export { ForwardRef as ReactComponent };